export default "__VITE_ASSET__f9fec8b4__"